import { Text } from "react-native"

export const Head = ({children, type = "h1", className}: {children: React.ReactNode, type?: THeadType, className?: string}) => {
    const styles = typeStyles[type]
    return <Text className={`text-black font-bold leading-normal ${styles} ${className}`}>{children}</Text>
}

type THeadType = "h1" | "h2" |  "h3"

const typeStyles = {
    h1: "text-5xl",
    h2: "text-3xl",
    h3: "text-lg",
}